// import i18n from '@/i18n'
import {createLogger} from './log'

import {
  StoreEvents,
  storeEventLister,
  manualEventListener,
} from './event-dispatcher'

const logger = createLogger('GTAG-Subscriber', '📊', false)

export const createGTAGListeners = (analyticstype, gtag) => {
  console.log(analyticstype, gtag)

  let subscribers = []
  if (analyticstype == 'gtag' || analyticstype == 'both') {
    //track product impression
    subscribers.push(
      storeEventLister(StoreEvents.SEARCH_PRODUCTS_UPDATED, m => {
        const products = m.payload.results

        logger.print('SEARCH_PRODUCTS_UPDATED', products)

        try {
          let searchItems = []
          products.forEach((element, index) => {
            searchItems.push({
              id: element.id,
              name: `${element.contact.name} - ${element.display}`,
              category: 'Urlaubsgutschein',
              brand: element.vendor.name,
              list_name: 'Suche',
              list_position: index + 1,
              quantity: 1,
              price: element.price.display,
            })
          }),
            gtag.event('view_item_list', {
              event_category: 'ecommerce',
              event_label: 'Search',
              items: searchItems,
            })
        } catch (err) {
          logger.error('Failed SEARCH_PRODUCTS_UPDATED', err)
        }
      }),
    )

    //track offerclick
    subscribers.push(
      manualEventListener('offer_clicked', payload => {
        logger.print('clicked offerelement', payload)
        const product = payload.product

        try {
          gtag.event('select_content', {
            content_type: 'product',
            event_category: 'ecommerce',
            event_label: 'ProductClick',
            items: [
              {
                id: product.id,
                name: product.display,
                category: 'Urlaubsgutschein',
                price: product.price.display,
              },
            ],
          })
        } catch (err) {
          logger.error('Failed HOTEL_OFFER_LOADED', err)
        }
      }),
    )

    //track item view
    subscribers.push(
      storeEventLister(StoreEvents.HOTEL_OFFER_LOADED, m => {
        const offer = m.payload
        logger.print('HOTEL_OFFER_LOADED', offer, offer.variants)

        try {
          gtag.event('view_item', {
            items: [
              {
                id: offer.id,
                name: offer.title,
                category: 'Urlaubsgutschein',
              },
            ],
          })
        } catch (err) {
          logger.error('Failed HOTEL_OFFER_LOADED', err)
        }
      }),
    )

    //track add to cart
    subscribers.push(
      storeEventLister(StoreEvents.PRODUCT_ADDED, m => {
        const cartItem = m.payload

        logger.print('PRODUCT_ADDED', cartItem)

        try {
          gtag.event('add_to_cart', {
            event_category: 'ecommerce',
            event_label: 'AddToCart',
            items: [
              {
                id: cartItem.id,
                name: `${cartItem.subtitle} - ${cartItem.title}`,
                category: 'Urlaubsgutschein',
                //brand: 'foo',
                list_name: 'Sucheresultat',
                list_position: 1,
                quantity: cartItem.quantity,
                variant: cartItem.variantId,
                price: cartItem.unitPrice,
              },
            ],
          })
        } catch (err) {
          logger.error('Failed PRODUCT_ADDED', err)
        }
      }),
    )

    //track remove from cart
    subscribers.push(
      storeEventLister(StoreEvents.PRODUCT_REMOVED, m => {
        const cartItem = m.payload

        logger.print('PRODUCT_REMOVED', cartItem)

        try {
          gtag.event('remove_from_cart', {
            event_category: 'ecommerce',
            event_label: 'RemoveFromCart',
            items: [
              {
                id: cartItem.id,
                name: `${cartItem.subtitle} - ${cartItem.title}`,
                category: 'Urlaubsgutschein',
                //brand: 'foo',
                list_name: 'Sucheresultat',
                list_position: 1,
                quantity: cartItem.quantity,
                variant: cartItem.variantId,
                price: cartItem.unitPrice,
              },
            ],
          })
        } catch (err) {
          logger.error('Failed PRODUCT_REMOVED', err)
        }
      }),
    )

    //track start checkout
    subscribers.push(
      manualEventListener('checkout_clicked', m => {
        const cartItems = m

        logger.print('CHECKOUT_PAYMENT_STARTED', cartItems)

        try {
          let cart = []

          cartItems.forEach((element, index) => {
            cart.push({
              id: element.id,
              name: `${element.title} - ${element.description}`,
              category: 'Urlaubsgutschein',
              list_name: 'Cart',
              list_position: index + 1,
              quantity: element.quantity,
              price: element.unitPrice,
            })
          })

          gtag.event('begin_checkout', {
            items: cart,
          })
        } catch (err) {
          logger.error('Failed CHECKOUT_PAYMENT_STARTED', err)
        }
      }),
    )

    //track purchase
    subscribers.push(
      storeEventLister(StoreEvents.CHECKOUT_ORDER_CLOSED, m => {
        const order = m.payload

        logger.print('CHECKOUT_ORDER_CLOSED', order)

        try {
          let purchasedItems = []

          order.orderItems.forEach(element => {
            purchasedItems.push({
              id: order.id,
              name: element.title,
              //brand. '',
              //category: '',
              price: element.unitPrice,
              quantity: element.quantity,
              variant: element.variantId,
              list_position: 1,
              //list_name: 'Search Results',
            })
          })

          gtag.purchase({
            transaction_id: order.id,
            //affiliation: 'Google online store',
            value: order.orderItems.reduce((a, c) => a + c.total, 0.0),
            currency: 'EUR',
            items: purchasedItems,
          })
        } catch (err) {
          logger.error('Failed ORDER_CLOSED', err)
        }
      }),
    )
  }
  return subscribers
}
